import axios from "axios";
import { API_URL } from "../config/api";

export const apiRequest = async (
  endpoint,
  method = "GET",
  data = {},
  params = {},
) => {
  const config = {
    method,
    url: `${API_URL}/${endpoint}`,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
    params: method === "GET" ? { ...params } : {},
    data: method !== "GET" ? { ...data } : null,
  };

  try {
    const response = await axios(config);
    if (response.data[0]?.error_msg) {
      throw new Error(response.data[0].error_msg);
    }
    return response.data;
  } catch (error) {
    console.error(`Błąd API: ${error.message}`);
    return null;
  }
};
